import { render, staticRenderFns } from "./Pos_Result_Items.vue?vue&type=template&id=2037b803&"
import script from "./Pos_Result_Items.vue?vue&type=script&lang=js&"
export * from "./Pos_Result_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports